import React from "react";

interface ServiceButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const RectButton: React.FC<ServiceButtonProps> = ({
  children,
  onClick,
  className = "",
  style = {},
}) => (
  <button
    className={`w-full bg-[#a0522d] text-white text-2xl tracking-wide px-10 py-6 rounded shadow-lg mb-4 ${className}`}
    style={{
      fontFamily: "'Courier New', Courier, monospace",
      boxShadow: "4px 4px 0 #222",
      ...style,
    }}
    onClick={onClick}
  >
    {children}
  </button>
);

export default RectButton;